import {
    defineComponent,
    ref,
    onMounted,
    onUnmounted,
    nextTick,
    watch
} from "/Scripts/vue.esm-browser.js";


const html = String.raw;

export default defineComponent({
    name: "MarketingSection",
    props: {
        currentTab: { type: String },
        marketingData: { type: Array },
    },
    emits: [],
    setup(props) {
        const marketingContainer = ref(null); // 綁定 DOM
        const swiperInstance = ref(null);
        const resizeTimer = ref(null);

        const initializeOrDestroySwiper = () => {
            const windowWidth = window.innerWidth;
            const container = marketingContainer.value;
            const wrapper = container?.querySelector(".marketing_wrap");

            if (!container || !wrapper) return;

            wrapper.classList.add("swiper-wrapper");
            Array.from(wrapper.children).forEach((child) => {
                child.classList.add("swiper-slide");
            });
            if (!swiperInstance.value) {
                swiperInstance.value = new Swiper(container, {
                    slidesPerView: "1",
                    slidesPerGroup: 1,
                    spaceBetween: 24,
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    }
                });
            }
        };

        const handleResize = () => {
            clearTimeout(resizeTimer.value);
            resizeTimer.value = setTimeout(() => {
                initializeOrDestroySwiper();
            }, 300);
        };

        onMounted(() => {
            nextTick(() => {
                initializeOrDestroySwiper();
                window.addEventListener("resize", handleResize);
            });
        });

        onUnmounted(() => {
            window.removeEventListener("resize", handleResize);
            if (swiperInstance.value && swiperInstance.value.destroy) {
                swiperInstance.value.destroy(true, true);
            }
        });

        const goToLink = (linkUrl) => {
            window.open(linkUrl, "_blank");
        };
        const getTargetUrl = (linkUrl) => {
            return linkUrl; // 返回目標URL
        }

        watch(
            () => props.currentTab,
            (newFilters) => {
                if (newFilters === 'marketing') {
                    initializeOrDestroySwiper();
                    window.addEventListener("resize", handleResize);
                }
            },
            { deep: true }
        );

        return {
            goToLink, getTargetUrl, marketingContainer
        };
    },
    template: html`
        <div
            class="marketing_campaign_wrap layout layout-2"
            :class="{ active: currentTab === 'marketing' }"
        >
            <div class="marketing_container slider-marketing slider" ref="marketingContainer">
                <div class="marketing_wrap">
                    <a class="marketing_campaign"
                        v-for="marketing in marketingData"
                        :href="marketing.linkUrl"
                        target="_blank"
                    >
                        <div class="marketing_campaign_img">
                            <img
                                :src="marketing.imageUrl"
                                class="marketing_BN"
                            />
                            <img
                                class="campaign_link_icon"
                                src="/Content/Img/Shop/campaign_link_icon.png"
                            />
                        </div>
                        <div class="marketing_campaign_txt">
                            {{ marketing.title }}
                        </div>
                    </a>
                </div>
            </div>
            <div class="swiper-button-next"></div>
            <div class="swiper-button-prev"></div>
        </div>
    `,
});
